import { dataServiceApi } from "contexts/axiosApiInstance";
import type { IdentityCandidates } from "./rowIdentityWire";

export * from "./rowIdentityWire";

/** Per-column uniqueness of one version of the table (the current one by
 *  default), unique first, with the identity that version stores. */
export async function fetchIdentityCandidates(
  tableId: string,
  version?: number,
): Promise<IdentityCandidates> {
  const res = await dataServiceApi.get<IdentityCandidates>(
    `/tables/${encodeURIComponent(tableId)}/identity-candidates`,
    { params: version === undefined ? undefined : { version } },
  );
  return res.data;
}
